import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { Button } from "@mui/material";
import IndividualMembershipController from "../Controller/individual_membership_controller.ts";
import { RiFileExcel2Line } from "react-icons/ri";

const IndividualMembershipListExcel = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    IndividualMembershipController.getDataForExcel().then((response) => {
      console.log(response);

      const formattedData = response.map((item, index) => {
        return {
          "No.": index + 1,
          "Name of Member": item.individual_name,
          "Name of Company": item.individual_place_of_employment,
          "Membership No.": item.memberID,
          "Address": item.individual_office_address,
          "Telephone": item.individual_office_tel_no,
          "Handphone No.": item.individual_hp_no,
          "Email": item.individual_email,
        };
      });

      setRows(formattedData);
    });
  }, []);

  const exportToExcel = () => {
    if (rows.length === 0) {
      alert("No data available!");
      return;
    }

    // Create worksheet with formatted data
    const worksheet = XLSX.utils.json_to_sheet(rows);

    // Auto-adjust column widths
    const columnWidths = Object.keys(rows[0]).map((key) => ({
      wch: Math.max(
        key.length, // Header length
        ...rows.map((row) => (row[key] ? row[key].toString().length : 0)) // Max data length
      ),
    }));

    worksheet["!cols"] = columnWidths;

    // Create workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Individual Membership List");

    // Export as .xlsx file
    XLSX.writeFile(workbook, `IndividualMembershipList.xlsx`);
  };

  return (
    <Button variant="contained" color="success" onClick={exportToExcel} sx={{ marginBottom: "20px", fontWeight: "bold" }}>
      <RiFileExcel2Line fontSize={20} style={{ marginRight: "10px" }} /> Excel
    </Button>
  );
};

export default IndividualMembershipListExcel;
